

// // pages/MyOrganization.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   ArrowLeft, 
//   Building2, 
//   Mail, 
//   Settings, 
//   Package, 
//   Edit, 
//   Save, 
//   X,
//   Phone,
//   MapPin,
//   Clock,
//   Users,
//   Briefcase,
//   Camera,
//   Trash2
// } from 'lucide-react';
// import api from '../common/apiClient';
// import SummaryApi from '../common/SummaryApi';
// import { toast } from 'react-toastify';

// const MyOrganization = () => {
//   const [organization, setOrganization] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editData, setEditData] = useState({});
//   const [activeTab, setActiveTab] = useState('overview');
//   const [imageUploading, setImageUploading] = useState(false);
//   const navigate = useNavigate();

//   const fetchOrganization = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await api.get(SummaryApi.getOrgDetails.url);

//       if (response.data.success) {
//         setOrganization(response.data.organization);
//         setEditData(response.data.organization);
//       }
//     } catch (error) {
//       console.error("Failed to fetch organization:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchOrganization();
//   }, [fetchOrganization]);

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Validate file type
//     const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//     if (!validTypes.includes(file.type)) {
//       toast.error('Please upload a valid image file (JPG, PNG, or WebP)');
//       return;
//     }

//     // Validate file size (5MB max)
//     if (file.size > 5 * 1024 * 1024) {
//       toast.error('Image size should be less than 5MB');
//       return;
//     }

//     setImageUploading(true);
//     const formData = new FormData();
//     formData.append('organizationPicture', file);

//     try {
//       const response = await api.put(SummaryApi.uploadOrgPicture.url, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       if (response.data.success) {
//         toast.success('Organization picture updated successfully');
//         setOrganization({
//           ...organization,
//           organizationPicture: response.data.organizationPicture
//         });
//         setEditData({
//           ...editData,
//           organizationPicture: response.data.organizationPicture
//         });
//       }
//     } catch (error) {
//       console.error("Error uploading organization picture:", error);
//       toast.error(error.response?.data?.message || 'Failed to upload image');
//     } finally {
//       setImageUploading(false);
//       // Reset file input
//       e.target.value = '';
//     }
//   };

//   const handleImageDelete = async () => {
//     if (!organization?.organizationPicture) return;

//     const confirmDelete = window.confirm('Are you sure you want to remove the organization picture?');
//     if (!confirmDelete) return;

//     setImageUploading(true);
//     try {
//       const response = await api.delete(SummaryApi.deleteOrgPicture.url);

//       if (response.data.success) {
//         toast.success('Organization picture removed successfully');
//         setOrganization({
//           ...organization,
//           organizationPicture: null
//         });
//         setEditData({
//           ...editData,
//           organizationPicture: null
//         });
//       }
//     } catch (error) {
//       console.error("Error deleting organization picture:", error);
//       toast.error(error.response?.data?.message || 'Failed to remove image');
//     } finally {
//       setImageUploading(false);
//     }
//   };

//   const handleEdit = () => setIsEditing(true);
  
//   const handleCancel = () => {
//     setIsEditing(false);
//     setEditData(organization);
//   };

//   const handleSave = async () => {
//     try {
//       const response = await api.put(SummaryApi.updateOrg.url, editData);

//       if (response.data.success) {
//         setOrganization(editData);
//         setIsEditing(false);
//         toast.success('Organization updated successfully');
//       }
//     } catch (error) {
//       console.error("Error updating organization:", error);
//       toast.error('Failed to update organization');
//     }
//   };

//   const handleInputChange = (field, value) => {
//     if (field.includes('.')) {
//       const [parent, child] = field.split('.');
//       setEditData({
//         ...editData,
//         [parent]: {
//           ...editData[parent],
//           [child]: value
//         }
//       });
//     } else {
//       setEditData({
//         ...editData,
//         [field]: value
//       });
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b sticky top-0 z-10">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center">
//               <button
//                 onClick={() => navigate(-1)}
//                 className="mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
//               >
//                 <ArrowLeft className="w-5 h-5" />
//               </button>
//               <h1 className="text-xl font-semibold">Organization Management</h1>
//             </div>
//             {!isEditing ? (
//               <button
//                 onClick={handleEdit}
//                 className="flex items-center px-4 py-2 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-lg hover:from-red-600 hover:to-pink-700 transition-all transform hover:scale-105 shadow-lg"
//               >
//                 <Edit className="w-4 h-4 mr-2" />
//                 Edit
//               </button>
//             ) : (
//               <div className="flex gap-2">
//                 <button
//                   onClick={handleSave}
//                   className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-lg"
//                 >
//                   <Save className="w-4 h-4 mr-2" />
//                   Save
//                 </button>
//                 <button
//                   onClick={handleCancel}
//                   className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
//                 >
//                   <X className="w-4 h-4 mr-2" />
//                   Cancel
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Organization Header with Cover */}
//       <div className="relative">
//         <div className="h-48 bg-gradient-to-r from-red-500 to-red-500"></div>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="relative -mt-24 pb-6">
//             <div className="bg-white rounded-lg shadow-xl p-6">
//               <div className="flex flex-col sm:flex-row items-center sm:items-end space-y-4 sm:space-y-0 sm:space-x-6">
//                 <div className="relative group">
//                   {organization?.organizationPicture ? (
//                     <>
//                       <img
//                         src={organization.organizationPicture}
//                         alt={organization.name}
//                         className="w-32 h-32 rounded-lg object-cover shadow-lg"
//                       />
//                       {imageUploading && (
//                         <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
//                           <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
//                         </div>
//                       )}
//                     </>
//                   ) : (
//                     <div className="w-32 h-32 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg flex items-center justify-center text-white text-4xl font-bold shadow-lg">
//                       {organization?.name?.charAt(0).toUpperCase()}
//                     </div>
//                   )}
                  
//                   {/* Image Actions */}
//                   <div className="absolute bottom-0 right-0 flex gap-1">
//                     <label className="bg-white rounded-full p-2 shadow-lg cursor-pointer hover:bg-gray-100 transition-colors">
//                       <Camera className="w-5 h-5 text-gray-700" />
//                       <input
//                         type="file"
//                         className="hidden"
//                         accept="image/*"
//                         onChange={handleImageUpload}
//                         disabled={imageUploading}
//                       />
//                     </label>
                    
//                     {organization?.organizationPicture && (
//                       <button
//                         onClick={handleImageDelete}
//                         disabled={imageUploading}
//                         className="bg-white rounded-full p-2 shadow-lg hover:bg-red-50 hover:text-red-600 transition-colors"
//                         title="Remove picture"
//                       >
//                         <Trash2 className="w-5 h-5" />
//                       </button>
//                     )}
//                   </div>
                  
//                   {/* Hover Overlay */}
//                   {!imageUploading && (
//                     <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100">
//                       <p className="text-white text-sm font-medium">
//                         {organization?.organizationPicture ? 'Update Picture' : 'Add Picture'}
//                       </p>
//                     </div>
//                   )}
//                 </div>
                
//                 <div className="flex-1 text-center sm:text-left">
//                   <h2 className="text-3xl font-bold text-gray-900">{organization?.name}</h2>
//                   <div className="flex flex-wrap items-center justify-center sm:justify-start gap-4 mt-2 text-sm text-gray-600">
//                     <span className="flex items-center">
//                       <Building2 className="w-4 h-4 mr-1" />
//                       {organization?.businessId}
//                     </span>
//                     <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
//                       organization?.status === 'active' 
//                         ? 'bg-green-100 text-green-700' 
//                         : 'bg-gray-100 text-gray-700'
//                     }`}>
//                       {organization?.status}
//                     </span>
//                     <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-semibold uppercase">
//                       {organization?.plan} Plan
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Tabs */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
//         <div className="bg-white rounded-lg shadow-sm">
//           <div className="flex overflow-x-auto">
//             {[
//               { id: 'overview', label: 'Overview', icon: Building2 },
//               { id: 'details', label: 'Details', icon: Settings },
//               { id: 'team', label: 'Team', icon: Users },
//               { id: 'billing', label: 'Billing', icon: Package },
//             ].map((tab) => {
//               const Icon = tab.icon;
//               return (
//                 <button
//                   key={tab.id}
//                   onClick={() => setActiveTab(tab.id)}
//                   className={`flex items-center space-x-2 px-6 py-4 border-b-2 transition-colors whitespace-nowrap ${
//                     activeTab === tab.id
//                       ? 'border-red-500 text-red-600 bg-red-50'
//                       : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
//                   }`}
//                 >
//                   <Icon className="w-4 h-4" />
//                   <span>{tab.label}</span>
//                 </button>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
//         {activeTab === 'overview' && (
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//             {/* Stats Cards */}
//             <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//               <div className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-gray-500 text-sm">Total Employees</p>
//                     <p className="text-2xl font-bold text-gray-900 mt-1">0</p>
//                   </div>
//                   <div className="p-3 bg-blue-100 rounded-lg">
//                     <Users className="w-6 h-6 text-blue-600" />
//                   </div>
//                 </div>
//               </div>
              
//               <div className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-gray-500 text-sm">Departments</p>
//                     <p className="text-2xl font-bold text-gray-900 mt-1">0</p>
//                   </div>
//                   <div className="p-3 bg-green-100 rounded-lg">
//                     <Building2 className="w-6 h-6 text-green-600" />
//                   </div>
//                 </div>
//               </div>
              
//               <div className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-gray-500 text-sm">Active Projects</p>
//                     <p className="text-2xl font-bold text-gray-900 mt-1">0</p>
//                   </div>
//                   <div className="p-3 bg-purple-100 rounded-lg">
//                     <Briefcase className="w-6 h-6 text-purple-600" />
//                   </div>
//                 </div>
//               </div>
              
//               <div className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-gray-500 text-sm">Plan</p>
//                     <p className="text-2xl font-bold text-gray-900 mt-1 uppercase">{organization?.plan}</p>
//                   </div>
//                   <div className="p-3 bg-red-100 rounded-lg">
//                     <Package className="w-6 h-6 text-red-600" />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Quick Info */}
//             <div className="lg:col-span-2 space-y-6">
//               <div className="bg-white rounded-lg shadow-sm p-6">
//                 <h3 className="text-lg font-semibold mb-4 flex items-center">
//                   <Building2 className="w-5 h-5 mr-2 text-red-500" />
//                   Organization Information
//                 </h3>
//                 <div className="space-y-4">
//                   <div className="flex justify-between items-center py-3 border-b">
//                     <span className="text-gray-600">Name</span>
//                     <span className="font-medium text-gray-900">{organization?.name}</span>
//                   </div>
//                   <div className="flex justify-between items-center py-3 border-b">
//                     <span className="text-gray-600">Business ID</span>
//                     <span className="font-medium text-gray-900">{organization?.businessId}</span>
//                   </div>
//                   <div className="flex justify-between items-center py-3 border-b">
//                     <span className="text-gray-600">Industry</span>
//                     <span className="font-medium text-gray-900">{organization?.settings?.industry}</span>
//                   </div>
//                   <div className="flex justify-between items-center py-3">
//                     <span className="text-gray-600">Company Size</span>
//                     <span className="font-medium text-gray-900">{organization?.settings?.companySize}</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="bg-white rounded-lg shadow-sm p-6">
//                 <h3 className="text-lg font-semibold mb-4 flex items-center">
//                   <Mail className="w-5 h-5 mr-2 text-red-500" />
//                   Contact Details
//                 </h3>
//                 <div className="space-y-4">
//                   <div className="flex items-center space-x-3">
//                     <Mail className="w-5 h-5 text-gray-400" />
//                     <span className="text-gray-900">{organization?.email}</span>
//                   </div>
//                   <div className="flex items-center space-x-3">
//                     <Phone className="w-5 h-5 text-gray-400" />
//                     <span className="text-gray-900">{organization?.mobile}</span>
//                   </div>
//                   <div className="flex items-center space-x-3">
//                     <MapPin className="w-5 h-5 text-gray-400" />
//                     <span className="text-gray-900">
//                       {organization?.settings?.state}, {organization?.settings?.country}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Activity Timeline */}
//             <div className="lg:col-span-1">
//               <div className="bg-white rounded-lg shadow-sm p-6">
//                 <h3 className="text-lg font-semibold mb-4 flex items-center">
//                   <Clock className="w-5 h-5 mr-2 text-red-500" />
//                   Recent Activity
//                 </h3>
//                 <div className="space-y-4">
//                   <div className="flex items-start space-x-3">
//                     <div className="w-2 h-2 bg-green-500 rounded-full mt-1.5"></div>
//                     <div>
//                       <p className="text-sm text-gray-900">Organization created</p>
//                       <p className="text-xs text-gray-500">
//                         {organization?.createdAt ? new Date(organization.createdAt).toLocaleDateString() : 'N/A'}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="flex items-start space-x-3">
//                     <div className="w-2 h-2 bg-blue-500 rounded-full mt-1.5"></div>
//                     <div>
//                       <p className="text-sm text-gray-900">Last updated</p>
//                       <p className="text-xs text-gray-500">
//                         {organization?.updatedAt ? new Date(organization.updatedAt).toLocaleDateString() : 'N/A'}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {activeTab === 'details' && (
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             {/* Basic Information */}
//             <div className="bg-white rounded-lg shadow-sm p-6">
//               <h3 className="text-lg font-semibold mb-4 flex items-center">
//                 <Building2 className="w-5 h-5 mr-2 text-red-500" />
//                 Basic Information
//               </h3>
//               <div className="space-y-4">
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Organization Name</label>
//                   <input
//                     type="text"
//                     value={isEditing ? editData.name : organization?.name}
//                     onChange={(e) => handleInputChange('name', e.target.value)}
//                     disabled={!isEditing}
//                     className={`w-full mt-1 px-4 py-2 border rounded-lg transition-colors ${
//                       isEditing 
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
//                         : 'border-gray-200 bg-gray-50 cursor-not-allowed'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Business ID</label>
//                   <input
//                     type="text"
//                     value={organization?.businessId}
//                     disabled
//                     className="w-full mt-1 px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed"
//                   />
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Slug</label>
//                   <input
//                     type="text"
//                     value={organization?.slug}
//                     disabled
//                     className="w-full mt-1 px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Contact Information */}
//             <div className="bg-white rounded-lg shadow-sm p-6">
//               <h3 className="text-lg font-semibold mb-4 flex items-center">
//                 <Mail className="w-5 h-5 mr-2 text-red-500" />
//                 Contact Information
//               </h3>
//               <div className="space-y-4">
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Email</label>
//                   <input
//                     type="email"
//                     value={isEditing ? editData.email : organization?.email}
//                     onChange={(e) => handleInputChange('email', e.target.value)}
//                     disabled={!isEditing}
//                     className={`w-full mt-1 px-4 py-2 border rounded-lg transition-colors ${
//                       isEditing 
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
//                         : 'border-gray-200 bg-gray-50 cursor-not-allowed'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Mobile</label>
//                   <input
//                     type="tel"
//                     value={isEditing ? editData.mobile : organization?.mobile}
//                     onChange={(e) => handleInputChange('mobile', e.target.value)}
//                     disabled={!isEditing}
//                     className={`w-full mt-1 px-4 py-2 border rounded-lg transition-colors ${
//                       isEditing 
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
//                         : 'border-gray-200 bg-gray-50 cursor-not-allowed'
//                     }`}
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Settings */}
//             <div className="bg-white rounded-lg shadow-sm p-6">
//               <h3 className="text-lg font-semibold mb-4 flex items-center">
//                 <Settings className="w-5 h-5 mr-2 text-red-500" />
//                 Organization Settings
//               </h3>
//               <div className="space-y-4">
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Industry</label>
//                   <input
//                     type="text"
//                     value={isEditing ? editData.settings?.industry : organization?.settings?.industry}
//                     onChange={(e) => handleInputChange('settings.industry', e.target.value)}
//                     disabled={!isEditing}
//                     className={`w-full mt-1 px-4 py-2 border rounded-lg transition-colors ${
//                       isEditing 
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
//                         : 'border-gray-200 bg-gray-50 cursor-not-allowed'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Company Size</label>
//                   <select
//                     value={isEditing ? editData.settings?.companySize : organization?.settings?.companySize}
//                     onChange={(e) => handleInputChange('settings.companySize', e.target.value)}
//                     disabled={!isEditing}
//                     className={`w-full mt-1 px-4 py-2 border rounded-lg transition-colors ${
//                       isEditing 
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
//                         : 'border-gray-200 bg-gray-50 cursor-not-allowed'
//                     }`}
//                   >
//                     <option value="1-10">1-10</option>
//                     <option value="11-50">11-50</option>
//                     <option value="50-100">50-100</option>
//                     <option value="100-500">100-500</option>
//                     <option value="500+">500+</option>
//                   </select>
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-600">Timezone</label>
//                   <input
//                     type="text"
//                     value={organization?.settings?.timezone}
//                     disabled
//                     className="w-full mt-1 px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Plan Details */}
//             <div className="bg-white rounded-lg shadow-sm p-6">
//               <h3 className="text-lg font-semibold mb-4 flex items-center">
//                 <Package className="w-5 h-5 mr-2 text-red-500" />
//                 Plan Details
//               </h3>
//               <div className="space-y-4">
//                 <div className="bg-gradient-to-r from-red-50 to-pink-50 p-4 rounded-lg">
//                   <div className="flex items-center justify-between mb-2">
//                     <span className="text-sm font-medium text-gray-600">Current Plan</span>
//                     <span className="px-3 py-1 bg-red-600 text-white text-sm font-semibold rounded-full uppercase">
//                       {organization?.plan}
//                     </span>
//                   </div>
//                   <p className="text-xs text-gray-500 mt-2">
//                     Member since {organization?.createdAt ? new Date(organization.createdAt).toLocaleDateString() : 'N/A'}
//                   </p>
//                 </div>
//                 <button className="w-full py-2 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-lg hover:from-red-600 hover:to-pink-700 transition-all transform hover:scale-105 font-medium">
//                   Upgrade Plan
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {activeTab === 'team' && (
//           <div className="bg-white rounded-lg shadow-sm p-6">
//             <div className="text-center py-12">
//               <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//               <h3 className="text-xl font-semibold text-gray-700 mb-2">No team members yet</h3>
//               <p className="text-gray-500 mb-6">Invite your team members to collaborate</p>
//               <button className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-lg hover:from-red-600 hover:to-pink-700 transition-all transform hover:scale-105 font-medium">
//                 Invite Team Members
//               </button>
//             </div>
//           </div>
//         )}

//         {activeTab === 'billing' && (
//           <div className="bg-white rounded-lg shadow-sm p-6">
//             <h3 className="text-lg font-semibold mb-6 flex items-center">
//               <Package className="w-5 h-5 mr-2 text-red-500" />
//               Billing & Subscription
//             </h3>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//               <div className="bg-gray-50 p-6 rounded-lg">
//                 <p className="text-gray-600 text-sm mb-1">Current Plan</p>
//                 <p className="text-2xl font-bold text-gray-900 uppercase">{organization?.plan}</p>
//               </div>
//               <div className="bg-gray-50 p-6 rounded-lg">
//                 <p className="text-gray-600 text-sm mb-1">Billing Cycle</p>
//                 <p className="text-2xl font-bold text-gray-900">Monthly</p>
//               </div>
//               <div className="bg-gray-50 p-6 rounded-lg">
//                 <p className="text-gray-600 text-sm mb-1">Next Billing Date</p>
//                 <p className="text-2xl font-bold text-gray-900">-</p>
//               </div>
//             </div>
//             <div className="border-t pt-6">
//               <h4 className="font-semibold mb-4">Payment History</h4>
//               <div className="text-center py-8 text-gray-500">
//                 <p>No payment history available</p>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MyOrganization;


// pages/MyOrganization.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  Building2, 
  Mail, 
  Settings, 
  Package, 
  Edit, 
  Save, 
  X,
  Phone,
  MapPin,
  Clock,
  Users,
  Briefcase,
  Camera,
  Trash2,
  Loader
} from 'lucide-react';
import api from '../common/apiClient';
import SummaryApi from '../common/SummaryApi';
import { toast } from 'react-toastify';
import { OrganizationSkeleton } from '../components/SkeletonComponents/OrganizationSkeleton';
import { formatDateTime } from '../helpers/formatDateTime';

const MyOrganization = () => {
  const { portalName } = useParams();
  const [organization, setOrganization] = useState(null);
  const [organizationStats, setOrganizationStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [activeTab, setActiveTab] = useState('overview');
  const [imageUploading, setImageUploading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const navigate = useNavigate();

  const fetchOrganization = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(SummaryApi.getOrgDetails.url);

      if (response.data.success) {
        const orgData = response.data.organization;
        setOrganization(orgData);
        // Ensure settings object exists
        setEditData({
          ...orgData,
          settings: orgData.settings || {}
        });
      }
    } catch (error) {
      console.error("Failed to fetch organization:", error);
      toast.error('Failed to load organization details');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrganization();
  }, [fetchOrganization]);

    const fetchOrganizationStats = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(SummaryApi.getOrgStats.url);

      if (response.data.success) {
        const orgStats = response.data.data;
        setOrganizationStats(orgStats);
        // Ensure settings object exists
        // setEditData({
        //   ...orgData,
        //   settings: orgData.settings || {}
        // });
      }
    } catch (error) {
      console.error("Failed to fetch organization Stats:", error);
      toast.error('Failed to load organization Stats');
    } finally {
      setLoading(false);
    }
  }, []);

    useEffect(() => {
    fetchOrganizationStats();
  }, [fetchOrganizationStats]);

  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      toast.error('Please upload a valid image file (JPG, PNG, or WebP)');
      e.target.value = '';
      return;
    }

    // Validate file size (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Image size should be less than 5MB');
      e.target.value = '';
      return;
    }

    setImageUploading(true);
    const formData = new FormData();
    formData.append('organizationPicture', file);

    try {
      const response = await api.put(SummaryApi.uploadOrgPicture.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        toast.success('Organization picture updated successfully');
        
        // Handle the response properly - check if full organization object is returned
        if (response.data.organization) {
          // If full organization object is returned
          const updatedOrg = response.data.organization;
          setOrganization(updatedOrg);
          setEditData(updatedOrg);
        } else {
          // If only picture URL is returned, update just the picture
          const newPictureUrl = response.data.organizationPicture || 
                              response.data.data?.organizationPicture;
          
          setOrganization(prev => ({
            ...prev,
            organizationPicture: newPictureUrl
          }));
          setEditData(prev => ({
            ...prev,
            organizationPicture: newPictureUrl
          }));
        }
      }
    } catch (error) {
      console.error("Error uploading organization picture:", error);
      toast.error(error.response?.data?.message || 'Failed to upload image');
    } finally {
      setImageUploading(false);
      e.target.value = '';
    }
  };

  const handleImageDelete = async () => {
    if (!organization?.organizationPicture) return;

    const confirmDelete = window.confirm('Are you sure you want to remove the organization picture?');
    if (!confirmDelete) return;

    setImageUploading(true);
    try {
      const response = await api.delete(SummaryApi.deleteOrgPicture.url);

      if (response.data.success) {
        toast.success('Organization picture removed successfully');
        setOrganization(prev => ({
          ...prev,
          organizationPicture: null
        }));
        setEditData(prev => ({
          ...prev,
          organizationPicture: null
        }));
      }
    } catch (error) {
      console.error("Error deleting organization picture:", error);
      toast.error(error.response?.data?.message || 'Failed to remove image');
    } finally {
      setImageUploading(false);
    }
  };

  const handleEdit = () => setIsEditing(true);
  
  const handleCancel = () => {
    setIsEditing(false);
    setEditData({
      ...organization,
      settings: organization?.settings || {}
    });
  };

  const handleSave = async () => {
    setSaveLoading(true);
    try {
      const response = await api.put(SummaryApi.updateOrg.url, {
        name: editData.name,
        email: editData.email,
        mobile: editData.mobile,
        settings: editData.settings
      });

      if (response.data.success) {
        // Use the full organization object from response
        const updatedOrg = response.data.organization;
        setOrganization(updatedOrg);
        setEditData(updatedOrg);
        setIsEditing(false);
        toast.success('Organization updated successfully');
      }
    } catch (error) {
      console.error("Error updating organization:", error);
      toast.error(error.response?.data?.message || 'Failed to update organization');
    } finally {
      setSaveLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setEditData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent] || {},
          [child]: value
        }
      }));
    } else {
      setEditData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  if (loading) {
    return <OrganizationSkeleton />;
  }

  return (
    <div className="">
      {/* Header - Responsive */}
      <div className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="mx-auto px-4">
          <div className="flex items-center justify-between h-12">
            <div className="flex items-center">
              <button
                onClick={() => navigate(-1)}
                className="mr-2 sm:mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <h1 className="text-lg sm:text-xl font-semibold truncate">Organization Management</h1>
            </div>
            {!isEditing ? (
              <button
                onClick={handleEdit}
                className="flex items-center px-3 sm:px-4 py-2 bg-gradient-to-r from-red-600 to-red-600 text-white rounded-lg hover:from-red-700 hover:to-red-700 transition-all transform hover:scale-105 shadow-lg text-sm sm:text-base"
              >
                <Edit className="w-4 h-4 mr-1 sm:mr-2" />
                <span className="hidden sm:inline">Edit</span>
              </button>
            ) : (
              <div className="flex gap-2">
                <button
                  onClick={handleSave}
                  disabled={saveLoading}
                  className="flex items-center px-3 sm:px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-lg disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
                >
                  {saveLoading ? (
                    <Loader className="w-4 h-4 mr-1 sm:mr-2 animate-spin" />
                  ) : (
                    <Save className="w-4 h-4 mr-1 sm:mr-2" />
                  )}
                  <span className="hidden sm:inline">Save</span>
                </button>
                <button
                  onClick={handleCancel}
                  disabled={saveLoading}
                  className="flex items-center px-3 sm:px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-50 text-sm sm:text-base"
                >
                  <X className="w-4 h-4 mr-1 sm:mr-2" />
                  <span className="hidden sm:inline">Cancel</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Organization Header with Cover - Responsive */}
      <div className="relative">
        <div className="h-32 sm:h-48 bg-gradient-to-r from-red-600 to-red-600"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative -mt-16 sm:-mt-24 pb-6">
            <div className="bg-white rounded-lg shadow-xl p-4 sm:p-6">
              <div className="flex flex-col sm:flex-row items-center sm:items-end space-y-4 sm:space-y-0 sm:space-x-6">
                <div className="relative group">
                  {organization?.organizationPicture ? (
                    <>
                      <img
                        src={organization.organizationPicture}
                        alt={organization.name || 'Organization'}
                        className="w-24 h-24 sm:w-32 sm:h-32 rounded-lg object-cover shadow-lg"
                        onError={(e) => {
                          // Fallback if image fails to load
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      {/* Fallback div - hidden by default */}
                      <div 
                        className="w-24 h-24 sm:w-32 sm:h-32 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg items-center justify-center text-white text-3xl sm:text-4xl font-bold shadow-lg hidden"
                      >
                        {organization?.name?.charAt(0).toUpperCase() || 'O'}
                      </div>
                      {imageUploading && (
                        <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
                          <Loader className="h-8 w-8 text-white animate-spin" />
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="w-24 h-24 sm:w-32 sm:h-32 bg-gradient-to-br from-red-600 to-red-600 rounded-lg flex items-center justify-center text-white text-3xl sm:text-4xl font-bold shadow-lg">
                      {organization?.name?.charAt(0).toUpperCase() || 'O'}
                    </div>
                  )}
                  
                  {/* Image Actions */}
                  {!saveLoading && (
                    <div className="absolute -bottom-2 -right-2 flex gap-1">
                      <label className={`bg-white rounded-full p-1.5 sm:p-2 shadow-lg cursor-pointer hover:bg-gray-100 transition-colors ${imageUploading ? 'opacity-50 cursor-not-allowed' : ''}`}>
                        <Camera className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
                        <input
                          type="file"
                          className="hidden"
                          accept="image/jpeg,image/jpg,image/png,image/webp"
                          onChange={handleImageUpload}
                          disabled={imageUploading}
                        />
                      </label>
                      
                      {organization?.organizationPicture && (
                        <button
                          onClick={handleImageDelete}
                          disabled={imageUploading}
                          className={`bg-white rounded-full p-1.5 sm:p-2 shadow-lg hover:bg-red-50 hover:text-red-600 transition-colors ${imageUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
                          title="Remove picture"
                        >
                          <Trash2 className="w-4 h-4 sm:w-5 sm:h-5" />
                        </button>
                      )}
                    </div>
                  )}
                  
                  {/* Hover Overlay */}
                  {!imageUploading && !saveLoading && (
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 pointer-events-none">
                      <p className="text-white text-sm font-medium">
                        {organization?.organizationPicture ? 'Update Picture' : 'Add Picture'}
                      </p>
                    </div>
                  )}
                </div>
                
                <div className="flex-1 text-center sm:text-left">
                  <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 break-words">{organization?.name}</h2>
                  <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2 sm:gap-4 mt-2 text-xs sm:text-sm text-gray-600">
                    <span className="flex items-center">
                      <Building2 className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                      {organization?.businessId}
                    </span>
                    <span className={`px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-semibold ${
                      organization?.status === 'active' 
                        ? 'bg-green-100 text-green-700' 
                        : 'bg-gray-100 text-gray-700'
                    }`}>
                      {organization?.status}
                    </span>
                    <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-red-100 text-red-700 rounded-full text-xs font-semibold uppercase">
                      {organization?.plan} Plan
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs - Responsive with horizontal scroll */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <div className="bg-white rounded-lg shadow-sm">
          <div className="flex overflow-x-auto scrollbar-hide">
            {[
              { id: 'overview', label: 'Overview', icon: Building2 },
              { id: 'details', label: 'Details', icon: Settings },
              { id: 'team', label: 'Team', icon: Users },
              { id: 'billing', label: 'Billing', icon: Package },
            ].map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 px-4 sm:px-6 py-3 sm:py-4 border-b-2 transition-colors whitespace-nowrap text-sm sm:text-base ${
                    activeTab === tab.id
                      ? 'border-red-500 text-red-600 bg-red-50'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content - Responsive */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        {activeTab === 'overview' && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6">
            {/* Stats Cards - Responsive Grid */}
            <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6">
              <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-xs sm:text-sm">Total Employees</p>
                    <p className="text-xl sm:text-2xl font-bold text-gray-900 mt-1">{organizationStats?.totalUsers}</p>
                  </div>
                  <div className="p-2 sm:p-3 bg-blue-100 rounded-lg">
                    <Users className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-xs sm:text-sm">Departments</p>
                    <p className="text-xl sm:text-2xl font-bold text-gray-900 mt-1">{organizationStats?.totalDepartments}</p>
                  </div>
                  <div className="p-2 sm:p-3 bg-green-100 rounded-lg">
                    <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-xs sm:text-sm">Divisions</p>
                    <p className="text-xl sm:text-2xl font-bold text-gray-900 mt-1">{organizationStats?.totalDivisions}</p>
                  </div>
                  <div className="p-2 sm:p-3 bg-purple-100 rounded-lg">
                    <Briefcase className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" />
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-xs sm:text-sm">Plan</p>
                    <p className="text-xl sm:text-2xl font-bold text-gray-900 mt-1 uppercase">{organization?.plan}</p>
                  </div>
                  <div className="p-2 sm:p-3 bg-red-100 rounded-lg">
                    <Package className="w-5 h-5 sm:w-6 sm:h-6 text-red-600" />
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Info - Responsive */}
            <div className="lg:col-span-2 space-y-4 sm:space-y-6">
              <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
                <h3 className="text-base sm:text-lg font-semibold mb-4 flex items-center">
                  <Building2 className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
                  Organization Information
                </h3>
                <div className="space-y-3 sm:space-y-4">
                  <div className="flex justify-between items-center py-2 sm:py-3 border-b">
                    <span className="text-gray-600 text-sm">Name</span>
                    <span className="font-medium text-gray-900 text-sm text-right break-words max-w-[60%]">{organization?.name}</span>
                  </div>
                  <div className="flex justify-between items-center py-2 sm:py-3 border-b">
                    <span className="text-gray-600 text-sm">Business ID</span>
                    <span className="font-medium text-gray-900 text-sm">{organization?.businessId}</span>
                  </div>
                  <div className="flex justify-between items-center py-2 sm:py-3 border-b">
                    <span className="text-gray-600 text-sm">Industry</span>
                    <span className="font-medium text-gray-900 text-sm">{organization?.settings?.industry || 'Not set'}</span>
                  </div>
                  <div className="flex justify-between items-center py-2 sm:py-3">
                    <span className="text-gray-600 text-sm">Company Size</span>
                    <span className="font-medium text-gray-900 text-sm">{organization?.settings?.companySize || 'Not set'}</span>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
                <h3 className="text-base sm:text-lg font-semibold mb-4 flex items-center">
                  <Mail className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
                  Contact Details
                </h3>
                <div className="space-y-3 sm:space-y-4">
                  <div className="flex items-center space-x-3">
                    <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 flex-shrink-0" />
                    <span className="text-gray-900 text-sm break-all">{organization?.email}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Phone className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 flex-shrink-0" />
                    <span className="text-gray-900 text-sm">{organization?.mobile}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 flex-shrink-0" />
                    <span className="text-gray-900 text-sm">
                      {organization?.settings?.state || 'Not set'}, {organization?.settings?.country || 'Not set'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Activity Timeline - Responsive */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
                <h3 className="text-base sm:text-lg font-semibold mb-4 flex items-center">
                  <Clock className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
                  Recent Activity
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-green-500 rounded-full mt-1.5"></div>
                    <div>
                      <p className="text-sm text-gray-900">Organization created</p>
                      <p className="text-xs text-gray-500">
                        {organization?.createdAt ? formatDateTime(organization.createdAt) : 'N/A'}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-1.5"></div>
                    <div>
                      <p className="text-sm text-gray-900">Last updated</p>
                      <p className="text-xs text-gray-500">
                        {organization?.updatedAt ? formatDateTime(organization.updatedAt) : 'N/A'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'details' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
            {/* Basic Information - Responsive */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <h3 className="text-base sm:text-lg font-semibold mb-4 flex items-center">
                <Building2 className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
                Basic Information
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-600">Organization Name</label>
                  <input
                    type="text"
                    value={isEditing ? editData.name : organization?.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    disabled={!isEditing || saveLoading}
                    className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
                      isEditing 
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
                        : 'border-gray-200 bg-gray-50 cursor-not-allowed'
                    }`}
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-600">Business ID</label>
                  <input
                    type="text"
                    value={organization?.businessId}
                    disabled
                    className="w-full mt-1 px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-sm"
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-600">Slug</label>
                  <input
                    type="text"
                    value={organization?.slug}
                    disabled
                    className="w-full mt-1 px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-sm"
                  />
                </div>
              </div>
            </div>

            {/* Contact Information - Responsive */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <h3 className="text-base sm:text-lg font-semibold mb-4 flex items-center">
                <Mail className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
                Contact Information
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-600">Email</label>
                  <input
                    type="email"
                    value={isEditing ? editData.email : organization?.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    disabled={!isEditing || saveLoading}
                    className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
                      isEditing 
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
                        : 'border-gray-200 bg-gray-50 cursor-not-allowed'
                    }`}
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-600">Mobile</label>
                  <input
                    type="tel"
                    value={isEditing ? editData.mobile : organization?.mobile}
                    onChange={(e) => handleInputChange('mobile', e.target.value)}
                    disabled={!isEditing || saveLoading}
                    className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
                      isEditing 
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
                        : 'border-gray-200 bg-gray-50 cursor-not-allowed'
                    }`}
                  />
                </div>
              </div>
            </div>

            {/* Settings - Responsive */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <h3 className="text-base sm:text-lg font-semibold mb-4 flex items-center">
                <Settings className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
                Organization Settings
              </h3>
              {/* <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-600">Industry</label>
                  <input
                    type="text"
                    value={isEditing ? (editData.settings?.industry || '') : (organization?.settings?.industry || '')}
                    onChange={(e) => handleInputChange('settings.industry', e.target.value)}
                    disabled={!isEditing || saveLoading}
                    className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
                      isEditing 
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
                        : 'border-gray-200 bg-gray-50 cursor-not-allowed'
                    }`}
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-600">Company Size</label>
                  <select
                    value={isEditing ? (editData.settings?.companySize || '') : (organization?.settings?.companySize || '')}
                    onChange={(e) => handleInputChange('settings.companySize', e.target.value)}
                    disabled={!isEditing || saveLoading}
                                        className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
                      isEditing 
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
                        : 'border-gray-200 bg-gray-50 cursor-not-allowed'
                    }`}
                  >
                    <option value="">Select size</option>
                    <option value="1-10">1-10</option>
                    <option value="11-50">11-50</option>
                    <option value="50-100">50-100</option>
                    <option value="100-500">100-500</option>
                    <option value="500+">500+</option>
                  </select>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-600">Timezone</label>
                  <input
                    type="text"
                    value={organization?.settings?.timezone || 'Not set'}
                    disabled
                    className="w-full mt-1 px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-sm"
                  />
                </div>
              </div> */}
              <div className="space-y-4">
  {/* --- Portal Name --- */}
  <div>
    <label className="text-sm font-medium text-gray-600">Portal Name</label>
    <input
      type="text"
      value={isEditing ? (editData.settings?.portalName || '') : (organization?.settings?.portalName || '')}
      onChange={(e) => handleInputChange('settings.portalName', e.target.value)}
      disabled={!isEditing || saveLoading}
      className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
        isEditing
          ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
          : 'border-gray-200 bg-gray-50 cursor-not-allowed'
      }`}
    />
  </div>

  {/* --- Industry --- */}
  <div>
    <label className="text-sm font-medium text-gray-600">Industry</label>
    <input
      type="text"
      value={isEditing ? (editData.settings?.industry || '') : (organization?.settings?.industry || '')}
      onChange={(e) => handleInputChange('settings.industry', e.target.value)}
      disabled={!isEditing || saveLoading}
      className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
        isEditing 
          ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
          : 'border-gray-200 bg-gray-50 cursor-not-allowed'
      }`}
    />
  </div>

  {/* --- Company Size --- */}
  <div>
    <label className="text-sm font-medium text-gray-600">Company Size</label>
    <select
      value={isEditing ? (editData.settings?.companySize || '') : (organization?.settings?.companySize || '')}
      onChange={(e) => handleInputChange('settings.companySize', e.target.value)}
      disabled={!isEditing || saveLoading}
      className={`w-full mt-1 px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm ${
        isEditing 
          ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500' 
          : 'border-gray-200 bg-gray-50 cursor-not-allowed'
      }`}
    >
      <option value="">Select size</option>
      <option value="1-10">1-10</option>
      <option value="11-50">11-50</option>
      <option value="50-100">50-100</option>
      <option value="100-500">100-500</option>
      <option value="500+">500+</option>
    </select>
  </div>

  {/* --- Timezone --- */}
  <div>
    <label className="text-sm font-medium text-gray-600">Timezone</label>
    <input
      type="text"
      value={organization?.settings?.timezone || 'Not set'}
      disabled
      className="w-full mt-1 px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-sm"
    />
  </div>
</div>

            </div>

            {/* Plan Details - Responsive */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <h3 className="text-base sm:text-lg font-semibold mb-4 flex items-center">
                <Package className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
                Plan Details
              </h3>
              <div className="space-y-4">
                <div className="bg-gradient-to-r from-red-50 to-red-50 p-4 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-600">Current Plan</span>
                    <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-red-600 text-white text-xs sm:text-sm font-semibold rounded-full uppercase">
                      {organization?.plan}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 mt-2">
                    Member since {organization?.createdAt ? formatDateTime(organization.createdAt) : 'N/A'}
                  </p>
                </div>
                <button className="w-full py-2 bg-gradient-to-r from-red-600 to-red-600 text-white rounded-lg hover:from-red-700 hover:to-red-700 transition-all transform hover:scale-105 font-medium text-sm sm:text-base">
                  Upgrade Plan
                </button>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'team' && (
          <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
            <div className="text-center py-8 sm:py-12">
              <Users className="w-12 h-12 sm:w-16 sm:h-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-lg sm:text-xl font-semibold text-gray-700 mb-2">No team members yet</h3>
              <p className="text-gray-500 mb-6 text-sm sm:text-base">Invite your team members to collaborate</p>
              <button
                 onClick={() => navigate(`/${portalName}/invitations/invite`)}
                 className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-red-600 to-red-600 text-white rounded-lg hover:from-red-700 hover:to-red-700 transition-all transform hover:scale-105 font-medium text-sm sm:text-base"
              >
               
                Invite Team Members
              </button>
            </div>
          </div>
        )}

        {activeTab === 'billing' && (
          <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
            <h3 className="text-base sm:text-lg font-semibold mb-6 flex items-center">
              <Package className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500" />
              Billing & Subscription
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-8">
              <div className="bg-gray-50 p-4 sm:p-6 rounded-lg">
                <p className="text-gray-600 text-xs sm:text-sm mb-1">Current Plan</p>
                <p className="text-xl sm:text-2xl font-bold text-gray-900 uppercase">{organization?.plan}</p>
              </div>
              <div className="bg-gray-50 p-4 sm:p-6 rounded-lg">
                <p className="text-gray-600 text-xs sm:text-sm mb-1">Billing Cycle</p>
                <p className="text-xl sm:text-2xl font-bold text-gray-900">Monthly</p>
              </div>
              <div className="bg-gray-50 p-4 sm:p-6 rounded-lg">
                <p className="text-gray-600 text-xs sm:text-sm mb-1">Next Billing Date</p>
                <p className="text-xl sm:text-2xl font-bold text-gray-900">-</p>
              </div>
            </div>
            <div className="border-t pt-6">
              <h4 className="font-semibold mb-4 text-sm sm:text-base">Payment History</h4>
              <div className="text-center py-8 text-gray-500 text-sm sm:text-base">
                <p>No payment history available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrganization;
